import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cac28fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["selected", "offline", "duplicate-license", "incompatible-version", "in-progress"]
const _hoisted_2 = {
  key: 0,
  class: "uptime-downtime--cell-content"
}
const _hoisted_3 = { class: "text-Text/text_high" }

import { Agent, Agent_Status, useSettingsPageWindowsQuery } from '@/graphql/codegen/generated/graphql';
import { computed, ref, onUnmounted, inject, watch } from 'vue';
import moment from 'moment';
import 'moment-timer';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentsTableUpTimeCell',
  props: {
    agent: null,
    selected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  agent: Agent | null | undefined;
  selected: boolean;
}


const currentTime = ref(new Date());
const currentTimeInterval = ref<ReturnType<typeof setInterval> | null>(null);
const coordinatorsService = inject(IKCoordinatorsService);
const GQL_Settings = useSettingsPageWindowsQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }), {});
onUnmounted(() => clearInterval(currentTimeInterval.value as any));
const reportInterval = computed(() => GQL_Settings?.result?.value?.ibManagerEntities?.settings?.windows?.agent?.reportInterval || 0);
const agentMetadata = computed(() => props.agent?.metadata);
const isAgentOffline = computed(() => props.agent?.status === Agent_Status.Offline);
watch(
  [reportInterval, isAgentOffline],
  ([newReportInterval, newIsAgentOffline]) => {
    if (newIsAgentOffline) {
      clearInterval(currentTimeInterval.value as any);
      currentTimeInterval.value = setInterval(() => {
        currentTime.value = new Date();
      }, (newReportInterval as any) * 1000);
    }
  },
  { immediate: true },
);
const duration = computed(() => {
  const counterField = !isAgentOffline.value ? props.agent?.upTime : Number(currentTime.value) - Number(props.agent?.lastConnected); // uptime for-> online agents --- since lastConnected for -> offline agents
  if (!counterField) {
    return '';
  }
  const diff = moment.duration(counterField);
  if (diff.days()) {
    return `${diff.days().toString().padStart(2, '0')}d ${diff.hours().toString().padStart(2, '0')}h ${diff.minutes().toString().padStart(2, '0')}m`;
  }
  return `${diff.hours().toString().padStart(2, '0')}h ${diff.minutes().toString().padStart(2, '0')}m ${diff.seconds().toString().padStart(2, '0')}s`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "uptime-downtime-duration",
    selected: __props.selected,
    offline: _unref(agentMetadata)?.isOffline,
    "duplicate-license": _unref(agentMetadata)?.isDuplicateLicense,
    "incompatible-version": _unref(agentMetadata)?.isIncompatibleVersion,
    "in-progress": _unref(agentMetadata)?.isInProgress
  }, [
    (_unref(duration))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass([[!_unref(isAgentOffline) ? 'uil uil-arrow-up app_text_green' : 'uil uil-arrow-down grey-arrow'], "text-[24px] ml-1 leading-6"])
          }, null, 2),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(duration)), 1)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})